import React from 'react';
import { IoSettingsOutline } from 'react-icons/io5';
import { IoMdHelpCircleOutline } from 'react-icons/io';
import { NavSubmenuLabel } from './navMenuLayout';

const SETTINGS_CHILD_ROUTES = [
  '/master-data/clients',
  '/master-data/departments',
  '/master-data/roles',
  '/master-data/equipment-categories',
  '/master-data/equipment-items',
  '/admin/users',
  '/access-control',
  '/admin/backups',
  '/company/backups',
  '/settings/company',
  '/settings/currencies',
  '/settings/display',
];

export default function SettingsHelpNavSection({
  MenuItem,
  SubMenuItem,
  ActionMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  isDemoProjectBootstrap,
  isSuperAdmin,
  isPlatformDeveloper,
  isAdmin,
  menusLoaded,
  user,
  onContactSupport,
  onAboutOpen,
}) {
  const showSettingsBlock = isDemoProjectBootstrap
    || hasMenuAccessOrChild('/settings', SETTINGS_CHILD_ROUTES)
    || isAdmin
    || isSuperAdmin
    || isPlatformDeveloper
    || Boolean(user && !isDemoProjectBootstrap);

  const showHelpBlock = menusLoaded && user;

  if (!showSettingsBlock && !showHelpBlock) {
    return null;
  }

  return (
    <>
      {showSettingsBlock && (
        <MenuItem customIcon={<IoSettingsOutline style={{ width: '24px', height: '24px' }} />} title="Settings" id="settings">
          {(hasMenuAccess('/master-data/clients')
            || (!isDemoProjectBootstrap && (
              hasMenuAccess('/master-data/departments')
              || hasMenuAccess('/master-data/roles')
              || hasMenuAccess('/master-data/equipment-categories')
              || hasMenuAccess('/master-data/equipment-items')
            ))) && (
            <>
              <NavSubmenuLabel>Master Data</NavSubmenuLabel>
              {hasMenuAccess('/master-data/clients') && <SubMenuItem to="/master-data/clients">Clients</SubMenuItem>}
              {!isDemoProjectBootstrap && hasMenuAccess('/master-data/departments') && (
                <SubMenuItem to="/master-data/departments">Departments</SubMenuItem>
              )}
              {!isDemoProjectBootstrap && hasMenuAccess('/master-data/roles') && (
                <SubMenuItem to="/master-data/roles">Job Positions</SubMenuItem>
              )}
              {!isDemoProjectBootstrap && hasMenuAccess('/master-data/equipment-categories') && (
                <SubMenuItem to="/master-data/equipment-categories">Equipment Categories</SubMenuItem>
              )}
              {!isDemoProjectBootstrap && hasMenuAccess('/master-data/equipment-items') && (
                <SubMenuItem to="/master-data/equipment-items">Equipment Items</SubMenuItem>
              )}
            </>
          )}
          {!isDemoProjectBootstrap && isSuperAdmin && (
            hasMenuAccess('/admin/users')
            || hasMenuAccess('/access-control')
            || hasMenuAccess('/admin/backups')
            || hasMenuAccess('/company/backups')
          ) ? (
            <>
              <NavSubmenuLabel className="mt-1">System</NavSubmenuLabel>
              {hasMenuAccess('/admin/users') && <SubMenuItem to="/admin/users">Users Management</SubMenuItem>}
              {hasMenuAccess('/access-control') && <SubMenuItem to="/access-control">Access Control</SubMenuItem>}
              {hasMenuAccess('/admin/backups') && <SubMenuItem to="/admin/backups">Backups</SubMenuItem>}
              {hasMenuAccess('/company/backups') && <SubMenuItem to="/company/backups">Company Backup</SubMenuItem>}
            </>
          ) : null}
          {!isDemoProjectBootstrap && user && (
            <>
              <NavSubmenuLabel className="mt-1">Preferences</NavSubmenuLabel>
              <SubMenuItem to="/settings/display">Display</SubMenuItem>
            </>
          )}
          {!isDemoProjectBootstrap && isAdmin && (
            <>
              <NavSubmenuLabel className="mt-1">Organization</NavSubmenuLabel>
              <SubMenuItem to="/settings/company">Company Settings</SubMenuItem>
              <SubMenuItem to="/settings/currencies">Currencies</SubMenuItem>
            </>
          )}
          {!isDemoProjectBootstrap && isPlatformDeveloper && (
            <SubMenuItem to="/platform">Access Developer</SubMenuItem>
          )}
        </MenuItem>
      )}
      {showHelpBlock && (
        <MenuItem customIcon={<IoMdHelpCircleOutline style={{ width: '24px', height: '24px' }} />} title="Help" id="help">
          <SubMenuItem to="/help/faq">FAQ</SubMenuItem>
          {hasMenuAccess('/help/manual') && <SubMenuItem to="/help/manual">User Manual</SubMenuItem>}
          <ActionMenuItem>Procedures</ActionMenuItem>
          <ActionMenuItem onClick={onContactSupport}>Contact Support</ActionMenuItem>
          <ActionMenuItem onClick={onAboutOpen}>About ArchonPM</ActionMenuItem>
        </MenuItem>
      )}
    </>
  );
}
